import { call, put } from "redux-saga/effects";

import { fetchCaseStudiesByIdSuccess, fetchCaseStudiesByIdSuccessFailure } from "domains/caseStudy/actions";
import type { CaseStudyFetch } from "domains/caseStudy/actionTypes";
import type { CaseStudyResponse, TopicCaseStudyPayload } from "domains/caseStudy/types";

export function* fetchCaseStudiesByIdSaga(action: CaseStudyFetch) {
  const { topicId } = action.payload;
  try {
    const response: Response = yield call(fetchPublicCaseStudies, action.payload);
    const { data }: CaseStudyResponse = yield call(() => response.json());
    yield put(fetchCaseStudiesByIdSuccess({ data, topicId }, action.payload));
  } catch {
    yield put(fetchCaseStudiesByIdSuccessFailure());
  }
}

const fetchPublicCaseStudies = ({ topicId, offset, limit }: TopicCaseStudyPayload) =>
  fetch(`https://fws.weforum.org/search/v1/public/case_studies?topicsContext=${topicId}&from=${offset}&size=${limit}`);
